import UserPlaceholderImage from 'assets/icons/User.svg'
import { FC } from 'react'
import styled, { css } from 'styled-components'

interface IUserImagePlaceholder {
  size?: 'small' | 'medium' | 'large' | 'extra-large'
  className?: string
  width?: string
  height?: string
}

const UserImagePlaceholder: FC<IUserImagePlaceholder> = ({ className, size = 'small', width, height }) => {
  return (
    <UserPlaceholder size={size} className={className} width={width} height={height}>
      <UserPlaceholderImage />
    </UserPlaceholder>
  )
}

export default UserImagePlaceholder

const UserPlaceholder = styled.div<{
  size: 'small' | 'medium' | 'large' | 'extra-large'
  width?: string
  height?: string
}>`
  background: ${({ theme }) => theme.colors.secondary_70};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 8px;

  ${({ size }) =>
    ({
      small: 'width: 40px; height: 40px;',
      medium: 'width: 50px!important; height: 50px;',
      large: 'width: 100px; height: 100px;',
      'extra-large': 'width: 240px; height: 240px; border-radius: 50%',
    }[size!])};

  svg {
    ${({ size }) =>
      ({
        small: 'width: 25px; height: 25px;',
        medium: 'width: 35px; height: 35px;',
        large: 'width: 80px; height: 80px;',
        'extra-large': 'width: 200px; height: 200px;',
      }[size!])};
  }

  ${({ width }) =>
    width &&
    css`
      width: ${width};
    `};
  ${({ height }) =>
    height &&
    css`
      height: ${height};
    `};
`
